module.exports = __webpack_public_path__ + "img/dashboard.d042ef71.svg";